import InputSelector from './InputSelector'

export default InputSelector
